import { useScrollContext } from "@navigations/utils/ScrollContext";
import styled, { useTheme } from "styled-components/native";
import FavoriteButton from "../GalleryView/utils/FavoriteButton";
import { GalleryCategory } from "../GalleryView/utils/GalleryType";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import ShareMenuWithoutTrigger from "../ShareMenuWithoutTrigger";
import ShareMenu from "../ShareMenu";
import ShareMenuiPadWrapper from "../ShareMenuiPadWrapper";
import { DeviceEventEmitter, TouchableOpacity, View } from "react-native";
import { Platform } from "react-native";
import { isThreeDEnabled } from "@utils/product/productValidators";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { css } from "styled-components/native";
import { MediaType } from "@utils/constants";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useSelector } from "react-redux";
import { useThreeDProperties } from "../../../contexts/ThreeDPropertiesContext";

type GalleryViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  ReceivedMedia: any;
  initialIndex?: number;
  image_thumb_url?: string;
  productType?: string;
  itemDetail?: any;
  fromMatchPair?: boolean;
  fromPDPScreen?: boolean;
  showExpand?: boolean;
  activeIndex: number;
  closeViewModal: (shareMediaUrl?: string) => void;
  isGuest?: boolean;
  shareMenuOpen?: boolean;
  setShareMenuOpen?: (open: any) => void;
  fromReviewPage?: boolean;
  setshowShareModal?: any;
  setSelectedOption?: any;
  isJewelryComponent?: boolean;
  isModal?: boolean;
};

const GalleryIconsView = ({
  isOpen,
  productType,
  itemDetail,
  fromMatchPair = false,
  fromPDPScreen,
  showExpand = false,
  ReceivedMedia,
  activeIndex,
  closeViewModal,
  isGuest = false,
  shareMenuOpen = false,
  setShareMenuOpen,
  fromReviewPage,
  setshowShareModal,
  setSelectedOption,
  isJewelryComponent,
  isModal,
}: GalleryViewModalProps) => {
  const theme = useTheme();
  const [scrollValue, ___, _____, ______, _______] = useScrollContext();
  const userInfo = useUserInfo();
  const { initStatus } = useOrgSettingsSlice();
  let isSmallDeviceWidth = !theme.isMobile ? true : false;
  let resizeImage = false;
  let isExternalView = GalleryCategory.ModelView;
  const flexDirection =
    theme.isLargeScreen && showExpand && fromPDPScreen ? "column" : "row";
  const isIPad = Platform.OS === "ios" && theme.isTablet;
  const three_d_settings = useSelector(
    (state: any) => state.globalData?.app_settings?.three_d
  );
  const { threeDProperties, setThreeDProperties } = useThreeDProperties();

  const rotate3D = () => {
    if (!isThreeDEnabled(itemDetail)) return;
    DeviceEventEmitter.emit("THREE_D_WEBVIEW", {
      iframeKey: [
        "vdb-gallery-iframe",
        "vdb-sticky-iframe",
        "vdb-overlay-iframe",
      ],
      data: {
        three_d_data_type:
          initStatus?.three_d_settings?.three_d_data_type ?? "webgi",
        functionName: "setAutoRotate",
        params: { enabled: !threeDProperties.autoRotate },
      },
    });
    setThreeDProperties((prevState: any) => ({
      ...prevState,
      autoRotate: !prevState.autoRotate,
    }));
  };

  const captureCanvas = () => {
    if (!isThreeDEnabled(itemDetail)) return;
    DeviceEventEmitter.emit("THREE_D_WEBVIEW", {
      iframeKey: ["vdb-overlay-iframe"],
      data: {
        three_d_data_type:
          initStatus?.three_d_settings?.three_d_data_type ?? "webgi",
        functionName: "captureCanvas",
        params: {},
      },
    });
  };

  return (
    <ContainerWrapper flexDirection={flexDirection}>
      <CenterContainer
        style={{ pointerEvents: Platform.OS === "web" ? "none" : "auto" }}
        flexDirection={flexDirection}
        fromMatchPair={fromMatchPair}
      >
        {!userInfo.isIFrame() && (
          <HeaderTopTextContainer
            isExternalView={isExternalView}
            fromMatchPair={fromMatchPair}
            fromPDPScreen={fromPDPScreen}
            flexDirection={flexDirection}
          >
            <RowView flexDirection={flexDirection}>
              <View style={{ pointerEvents: "auto" }}>
                <TouchableOpacity
                  onPress={() => closeViewModal()}
                  activeOpacity={0.8}
                >
                  <IconContainer>
                    <VDBIcon
                      name={VDBIcons.COLLAPSE}
                      size={24}
                      color={theme["core-06"]}
                      variant={IconsVariant.VDBCustom}
                    />
                  </IconContainer>
                </TouchableOpacity>
              </View>
              {!!isThreeDEnabled(itemDetail) &&
                ReceivedMedia?.[activeIndex]?.type === MediaType.MODEL_3D && (
                  <View style={{ pointerEvents: "auto" }}>
                    <TouchableOpacity onPress={rotate3D} activeOpacity={0.8}>
                      <IconContainer>
                        <VDBIcon
                          name={
                            threeDProperties.autoRotate
                              ? VDBIcons.THREE_D_PAUSE
                              : VDBIcons.THREE_D_PLAY
                          }
                          size={24}
                          color={theme["core-06"]}
                          variant={IconsVariant.VDBCustom}
                        />
                      </IconContainer>
                    </TouchableOpacity>
                  </View>
                )}
              {Platform.OS === "web" &&
                !!isThreeDEnabled(itemDetail) &&
                (three_d_settings?.showScreenshotIcon ?? false) &&
                ReceivedMedia?.[activeIndex]?.type === MediaType.MODEL_3D && (
                  <View style={{ pointerEvents: "auto" }}>
                    <TouchableOpacity
                      onPress={captureCanvas}
                      activeOpacity={0.8}
                    >
                      <IconContainer>
                        <VDBIcon
                          name={VDBIcons.SCREENSHOT}
                          size={24}
                          color={theme["core-06"]}
                          variant={IconsVariant.VDBCustom}
                        />
                      </IconContainer>
                    </TouchableOpacity>
                  </View>
                )}
            </RowView>
            {!isGuest ? (
              <RowView flexDirection={flexDirection}>
                {!isJewelryComponent && (
                  <View pointerEvents="auto">
                    {isIPad ? (
                      <ShareMenuiPadWrapper
                        setSelectedOption={setSelectedOption}
                        setshowShareModal={setshowShareModal}
                        showExpand={false}
                        isOpen={shareMenuOpen}
                        isSmallDeviceWidth={isSmallDeviceWidth}
                        resizeImage={resizeImage}
                        itemDetail={itemDetail}
                        mediaUrl={ReceivedMedia?.[activeIndex]?.link}
                        setShareMenuOpen={(open: boolean) => {
                          if (setShareMenuOpen) setShareMenuOpen(open);
                        }}
                        onShareViaNative={(mediaUrl: string) =>
                          closeViewModal(mediaUrl)
                        }
                        productType={productType}
                      />
                    ) : theme.isLargeScreen ? (
                      <ShareMenuWithoutTrigger
                        setSelectedOption={setSelectedOption}
                        setshowShareModal={setshowShareModal}
                        showExpand={false}
                        isOpen={shareMenuOpen}
                        isSmallDeviceWidth={isSmallDeviceWidth}
                        resizeImage={resizeImage}
                        itemDetail={itemDetail}
                        mediaUrl={ReceivedMedia?.[activeIndex]?.link}
                        setShareMenuOpen={(open: boolean) => {
                          if (setShareMenuOpen) setShareMenuOpen(open);
                        }}
                        productType={productType}
                      />
                    ) : (
                      <ShareMenu
                        setSelectedOption={setSelectedOption}
                        setshowShareModal={setshowShareModal}
                        showExpand={false}
                        isOpen={isOpen}
                        isSmallDeviceWidth={isSmallDeviceWidth}
                        resizeImage={resizeImage}
                        itemDetail={itemDetail}
                        mediaUrl={ReceivedMedia?.[activeIndex]?.link}
                        useRNModal={true}
                        isModal={isModal}
                        onShareViaNative={(mediaUrl: string) =>
                          closeViewModal(mediaUrl)
                        }
                        productType={productType}
                      />
                    )}
                  </View>
                )}
                {!fromReviewPage && (
                  <View style={{ pointerEvents: "auto" }}>
                    <FavoriteButton
                      productType={productType}
                      itemDetail={itemDetail}
                      scrollValue={scrollValue}
                      isMatchPairScreen={isSmallDeviceWidth}
                      isOpen={isOpen}
                      showExpand={showExpand}
                      resizeImage={resizeImage}
                      renderCollectionInWindow={
                        Platform.OS !== "web" && !theme.isLargeScreen
                      }
                    />
                  </View>
                )}
              </RowView>
            ) : null}
          </HeaderTopTextContainer>
        )}
      </CenterContainer>
    </ContainerWrapper>
  );
};

// Defined at module scope (not inside the component) so its identity is stable
// across re-renders. Previously this was declared inside GalleryIconsView, so
// every re-render created a new component type and React remounted the whole
// subtree (including FavoriteButton), wiping the open collection picker state.
const ContainerWrapper = ({
  children,
  flexDirection,
}: {
  children: React.ReactNode;
  flexDirection: string;
}) => {
  return Platform.OS === "web" ? (
    <CenterFlexContainer flexDirection={flexDirection}>
      {children}
    </CenterFlexContainer>
  ) : (
    <>{children}</>
  );
};

const CenterFlexContainer = styled.View<{ flexDirection: string }>`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  flex-direction: ${({ flexDirection }) => flexDirection};
  justify-content: space-between;
  align-items: center;
  ${({ flexDirection }) =>
    flexDirection === "row" &&
    css`
      width: 100%;
    `}
`;

const RowView = styled.View<{ flexDirection: string }>`
  flex-direction: ${({ flexDirection }) => flexDirection};
`;

const CenterContainer = styled.View<{
  flexDirection: string;
  fromMatchPair: boolean;
}>`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  ${({ fromMatchPair }) =>
    fromMatchPair &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
  flex-direction: ${({ flexDirection }) => flexDirection};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const HeaderTopTextContainer = styled.View<{
  isExternalView: keyof typeof GalleryCategory;
  fromMatchPair?: any;
  fromPDPScreen?: any;
  flexDirection: string;
}>`
  flex-direction: ${({ flexDirection }) => flexDirection};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const IconContainer = styled.View<any>`
  padding: ${SpaceType.Basic}px;
`;

export default GalleryIconsView;
